import { CommonModule, DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { EvCore } from "ev-core";
import { ICommercialSale } from "src/models/commercial/ICommercialSale";
import { CommercialSalesDataService } from "src/services/commercial/commercial-sales-data.service";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";

@Component({
    selector: "commercial-sale-item",
    imports: [CommonModule, EvCore, DatePipe],
    templateUrl: "./commercial-sale-item.component.html",
    styleUrl: "./commercial-sale-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialSaleItemComponent {
    sale = input.required<ICommercialSale>();

    authService: EvAuthorizationService = inject(EvAuthorizationService);
    private readonly commercialSalesDataService: CommercialSalesDataService = inject(CommercialSalesDataService);

    selectSale(sale: ICommercialSale): void {
        this.commercialSalesDataService.setSelectedSale(sale);
    }
}
